export { getGlobalConfig } from './libs/utils'
